export default {
    en: {
        id: 'exercise2',
        subtitle: 'SUGGESTED STRUCTURE <br> LOCATION BASED LEARNING STRATEGY',
        blocks: [
            {
                task: 'Location-Based Learning is $12m, market, experiencing healthy growth. Addresses same market Turner does, has no dominant players.',
                title: "S = ",
                answer: ' ',
                note: 'Sit, DE R1',
                disableEdit: true
            },
            {
                task: 'Research indicates a gap in the offerings of both segments that Turner might fill, if it could differentiate its offering sufficiently to become the dominant player.',
                title: "C = ",
                answer: ' ',
                note: 'Sol, R2',
                disableEdit: true
            },
            {
                task: 'How differentiate itself to become dominant player?',
                title: "Q = ",
                answer: ' ',
                disableEdit: true
            }
        ],
        image: '5c1-2.png',
        withoutAnswers: true,
        hideTaskTitle: true,
        submitButton: 'switch'
    },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise2.js